<template>
  <!-- <vue-drag-drop-snap
    starting-position="TR"
    :noStyle="true"
    :autoSnap="false"
  > -->
  <div class="mapPersonList" v-if="status != -1">
    <div style="text-align: center" v-if="status == 0">
      <i class="el-icon-loading"></i>
    </div>
    <!-- <div class="listHeader">
      <span>最近人员</span>
      <i
        :class="
          loading
            ? 'el-icon-loading'
            : showConent
            ? 'el-icon-arrow-up'
            : 'el-icon-arrow-down'
        "
        @click="showConent = !showConent"
      ></i>
    </div>
    <div class="divider"></div> -->
    <div class="listContent" v-if="data.length > 0">
      <div
        v-for="(item, index) in data.slice(0, count)"
        :key="index"
        class="item"
      >
        <p>{{ $l("姓名：") }}{{ item.userName }}</p>
        <p>
          {{ $l("距离：")
          }}<span style="color: red">{{ Math.round(item.distance) }}</span
          >{{ $l("米") }}
        </p>
      </div>
    </div>
  </div>
  <!-- </vue-drag-drop-snap> -->
</template>

<script>
// import VueDragDropSnap from "vue-drag-drop-snap";
export default {
  name: "mapPersonList",
  // components: {
  //   VueDragDropSnap,
  // },
  props: {
    data: {
      type: Array,
      default: [],
    },
    status: {
      type: Number,
      default: 0, //-1失败，0初始，1成功
    },
    count: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped lang="scss">
.mapPersonList {
  position: absolute;
  top: 6px;
  right: 6px;
  min-width: 100px;
  z-index: 2;
  overflow: hidden;
  border-radius: 4px;
  border: 1px solid #efefef;
  background-color: #f5f3f0;
  color: #383e47;
  transition: 0.3s;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  font-size: 12px;
  // .listHeader {
  //   padding: 0px 10px;
  //   height: 30px;
  //   span {
  //     display: block;
  //     float: left;
  //     line-height: 30px;
  //   }
  //   i {
  //     display: block;
  //     float: right;
  //     line-height: 30px;
  //     cursor: pointer;
  //   }
  // }
  // .divider {
  //   height: 1px;
  //   background-color: #dcdddd;
  // }
  .listContent {
    padding: 6px 10px;
    width: 100%;
    max-height: 300px;
    overflow: auto;
  }
}
.drag-drop-snap {
  right: unset !important;
}
</style>
